import ServiceIdentityFilter from './ServiceIdentityFilter';

export default ServiceIdentityFilter;
